import React from 'react';
import {
  HandHeart, Sparkles, ShieldCheck, Users, BookOpen, Flower2, Clock,
  UserCheck, MapPin, Gift, CalendarDays, ClipboardList, CreditCard,
  BellRing, BadgeCheck, Lock, Sunrise, Droplets, Flame, Sun, Wind, Moon,
  Utensils, Crown, Star, Bell, Music, Flower,
} from 'lucide-react';

const MAP = {
  HandHeart, Sparkles, ShieldCheck, Users, BookOpen, Flower2, Clock,
  UserCheck, MapPin, Gift, CalendarDays, ClipboardList, CreditCard,
  BellRing, BadgeCheck, Lock, Sunrise, Droplets, Flame, Sun, Wind, Moon,
  Utensils, Crown, Star, Bell, Music, Flower,
};

const Icon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp {...props} />;
};

export default Icon;
